import { TSelfregSessionStates } from '@routes/selfreg/utils/getSessionStates';
import { useSelfregSessionStates } from '@routes/selfreg/hooks/useSelfregSessionStates';
import { TSelfregSessionDetails } from '@api/io/selfreg.io';
import { Tag, useTagMap } from '@hooks/tags/useTagMap';
import { useProgressTag } from '@hooks/tags/useProgressTag';

const TAG_STATES = [
  'sessionFull',
  'placedInWaitlist',
  'numberedPlaceInWaitlist',
  'enrollmentPending',
] as const;
type TagStates = Extract<TSelfregSessionStates, typeof TAG_STATES>;

const isTagState = (value: string): value is TagStates => {
  return TAG_STATES.includes(value as TagStates);
};

export const useSelfregSessionDetailsTags = (
  sessionDetails: TSelfregSessionDetails,
) => {
  const progressTag = useProgressTag(sessionDetails.selfEnrollmentProgress);
  const sessionStates = useSelfregSessionStates(sessionDetails);

  const tagMap = useTagMap({});

  const sessionStateTags = Object.entries(sessionStates).reduce(
    (acc, [key, value]) => {
      if (value && isTagState(key)) {
        return {
          ...acc,
          [key]: tagMap[key as TagStates],
        };
      }

      return acc;
    },
    {} as Record<TagStates, Tag>,
  );

  return {
    progressTag,
    ...sessionStateTags,
  };
};
